import { Component, OnInit, HostListener, Input, EventEmitter,  Output,  Inject,} from '@angular/core';
import * as L from 'leaflet';
import { PublicService } from "../../api/public.service";
import { Station, StationDetail} from '../../models/api_models/station';
import {  StationService} from 'src/app/api/station.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export class StationData {
  id: number;
}

@Component({
  selector: 'app-leaflet-map-station-zoom',
  templateUrl: './leaflet-map-station-zoom.component.html',
  styleUrls: ['./leaflet-map-station-zoom.component.scss']
})
export class LeafletMapStationZoomComponent implements OnInit {
  private _map = null;
  private _group = null;
  private _mapIsLoad = false;
  private _stationLoad = false;
  private _currentGps: [number, number] = [0, 3.0599573];



  private _station: StationDetail = null;
  public get station(): StationDetail {
    return this._station;
  }
  @Input()
  public set station(station: StationDetail) {
    if (station != null) {
      this._station = station;
    }
  }



  private _stationId: number = null;
  public get stationId() {
    return this._stationId;
  }
  @Input()
  public set stationId(stationId) {
    if (stationId != null) {
      this._stationId = stationId;
      this.stationService.getStationDetailFromId(this._stationId).subscribe(
        response => {
          // console.log(response);
          
          this._station = response;
          this._currentGps = [this._station.latitude, this._station.longitude];
          this._stationLoad = true;
          this.displayStation();
        },
        error => {
          this._station = null;
          this._stationLoad = true;
        }
      )
    }
  }

  private displayStation() {
    if (this._stationLoad && this._mapIsLoad) {
      const myIcon = [
        L.icon({
          iconUrl: 'assets/icon/marker-autopartage.svg',
          iconSize: [32, 32],
        }),
        L.icon({
          iconUrl: 'assets/icon/marker-recharge.svg',
          iconSize: [32, 32],
        }),null,null,null,null,null,  
         L.icon({
          iconUrl: 'assets/icon/marker-recharge.svg',
          iconSize: [32, 32],
        }),null,null,null,

        L.icon({
          iconUrl: 'assets/icon/marker-recharge.svg',
          iconSize: [32, 32],
        }),

      ];


      L.marker(this._currentGps, {
        icon: myIcon[0],
        alt: this._station.name,
      }).addTo(this._group)
      if (this._mapIsLoad) {
        this._map.setView(this._currentGps, 12);
      }
    }
  }

  constructor( @Inject(MAT_DIALOG_DATA) public data : StationData = null, private stationService: StationService) {
      this.stationId = 140;
  }

  intiLeaflet() {

    this._map = L.map('map').setView(this._currentGps, 12);


    this._group = L.featureGroup().addTo(this._map);
    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {}).addTo(this._map);


    const myIcon = L.icon({
      iconUrl: 'assets/icon/marker.png',
      iconSize: [32, 32],
    });
    this._mapIsLoad = true
    this.displayStation();

    }

    ngOnInit() {
      this.intiLeaflet();
    }

  }
